module.exports = __webpack_public_path__ + "img/fatherhood_3.87f66d24.jpg";